import { FormattedMessage } from 'react-intl';
import { Stack } from "@mui/material";
import { ButtonMain } from "../customComponent/button";
import { FileDownloadOutlinedIcon, ArrowForwardOutlinedIcon } from "../../constants/images";

const ButtonReportData = (props) => {
  const { colorSystem, clickDownloadReport, setCurrentTab, scrollToAnchor } = props;

  return (
    <Stack id="scrollDown" variant='end-center'>
      <ButtonMain
        variant="contained"
        color={colorSystem}
        sx={{ mr: 2 }}
        onClick={clickDownloadReport}
      >
        <FileDownloadOutlinedIcon />
        <FormattedMessage id="common.button.downloadReport" />
      </ButtonMain>

      <ButtonMain
        variant="contained"
        color={colorSystem}
        onClick={() => {
          setCurrentTab(1);
          scrollToAnchor('scrollTop');
        }}
      >
        <FormattedMessage id="common.title.setMail" />
        <ArrowForwardOutlinedIcon sx={{ ml: 1 }} />
      </ButtonMain>
    </Stack>
  )
}

export default ButtonReportData;